<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="processing...">
  </mat-progress-bar>
</section>

<section [hidden]="loading || processing">
  <div fxLayout="row wrap" class="matero-row">
    &nbsp;&nbsp; 
    <button id="btnAddTreatment" mat-raised-button color="primary" title="Add Treatment" (click)="addTreatment()" [disabled]="authService.isReadOnly()"><mat-icon>add</mat-icon> Add Treatment</button>
  </div>
  <br />
  <mat-card> 
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
      <strong class="noMarginHeader">Treatments ({{resultSize}})</strong>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <mat-form-field style="width:200px;">
        <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
      </mat-form-field>
      <a (click)="load()"><mat-icon>refresh</mat-icon> </a>
     
      <br />
      <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <mat-row>Results ({{resultSize}})</mat-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        
        <ng-container matColumnDef="treatmentId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Treatment Id</mat-header-cell>
          <mat-cell *matCellDef="let result"> 
            <a (click)="editTreatment(result.treatmentId)"  *ngIf="result.treatmentId != null && result.treatmentId > 0"
            title="Edit Treatment {{result.treatmentId}}">{{result.treatmentId}}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="statusOfInstall">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status Of Install</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span>{{result.statusOfInstall}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="installedBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Installed By</mat-header-cell>
          <mat-cell *matCellDef="let result">          
            {{result.installedBy}}
          </mat-cell>
        </ng-container> 
        <ng-container matColumnDef="treatmentInstallCompletionDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header id="treatmentInstallCompletionDateHeader">Treatment Install<br>Completion Date</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span class="text-red-400" *ngIf="result.treatmentInstallCompletionDate">
              <span>{{result.treatmentInstallCompletionDate}}</span>
            </span> 
          </mat-cell>
        </ng-container> 

        <ng-container matColumnDef="latestFilterChangeDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Latest Filter<br>Change Date</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span class="text-red-400" *ngIf="result.latestFilterChangeDate">
              <span>{{result.latestFilterChangeDate}}</span>
            </span> 
          </mat-cell>
        </ng-container> 
         
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <a href="javascript:void(0)" *ngIf="result.treatmentId > 0 "
              (click)="deleteTreatment(result.treatmentId)" title="Delete Treatment {{result.treatmentId}}">
              <mat-icon>delete</mat-icon>
            </a>
          </mat-cell>  
        </ng-container>
        
      </mat-table>
      <br />
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator> 
    </div> 
  </mat-card>
</section>